export default {
  namespaced: true,
  state: {
    isConnected: false,
    roomUsers: [],
  },
  getters: {
    getIsConnected: (state) => state.isConnected,
    getRoomUsers: (state) => state.roomUsers,
  },
  mutations: {
    setIsConnected: (state, isConnected) => (state.isConnected = isConnected),
    setRoomUsers: (state, roomUsers) => (state.roomUsers = roomUsers),
  },
  actions: {
    applyRoomUsers: ({ commit }, users) => {
      commit('setRoomUsers', users);
    },
  },
};
